/**
 * Breakpoints configuration for mobile-first approach
 * Based on the existing CSS custom properties
 */
export const breakpoints = {
  values: {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536,
  },
};